import { render, staticRenderFns } from "./SupportTicketDetail.vue?vue&type=template&id=8af2d712&scoped=true"
import script from "./SupportTicketDetail.vue?vue&type=script&lang=js"
export * from "./SupportTicketDetail.vue?vue&type=script&lang=js"
import style0 from "./SupportTicketDetail.vue?vue&type=style&index=0&id=8af2d712&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8af2d712",
  null
  
)

export default component.exports